<template>
  <div class="gallery container">
    <v-gallery-horizontal
      :images="galleryImages"
      @image-idx="imageClicked"
    ></v-gallery-horizontal>

    <!-- LIGHT-BOX -->
    <v-light-box
      :showLightbox="lightbox"
      @hideLightbox="lightbox = false"
      :images="lightboxGallery"
      :startAt="lightboxIdx"
    ></v-light-box>
  </div>
</template>

<script>
import VGalleryHorizontal from '@/components/atomic/VGalleryHorizontal.vue';
import VLightBox from '@/components/atomic/VLightBox.vue';

export default {
  name: 'AgiosGalleryHorizontal',
  components: {
    VGalleryHorizontal,
    VLightBox,
  },
  data() {
    return {
      lightbox: false,
      lightboxIdx: 0,
      galleryImages: [
        {
          url:
            'https://res.cloudinary.com/rizeshouse/image/upload/e_auto_color,e_auto_saturation,e_auto_brightness,e_auto_contrast,c_scale,q_auto:best,w_250/v1628782779/AgiosPage/agios-4_fzccbq.jpg',
          caption: 'Από Wolfgang Reiter',
        },
        {
          url:
            'https://res.cloudinary.com/rizeshouse/image/upload/e_auto_color,e_auto_saturation,e_auto_brightness,e_auto_contrast,c_scale,q_auto:best,w_250/v1628782769/AgiosPage/agios-5_p3muux.jpg',
          caption: 'Από Wolfgang Reiter',
        },
        {
          url:
            'https://res.cloudinary.com/rizeshouse/image/upload/e_auto_color,e_auto_saturation,e_auto_brightness,e_auto_contrast,c_scale,q_auto:best,w_250/v1628782782/AgiosPage/agios-6_vpfz1a.jpg',
          caption: 'Από Wolfgang Reiter',
        },
        {
          url:
            'https://res.cloudinary.com/rizeshouse/image/upload/e_auto_color,e_auto_saturation,e_auto_brightness,e_auto_contrast,c_scale,q_auto:best,w_250/v1628782772/AgiosPage/agios-7_cpqlcw.jpg',
          caption: 'Από Wolfgang Reiter',
        },
      ],
      lightboxGallery: [
        'https://res.cloudinary.com/rizeshouse/image/upload/e_auto_color,e_auto_saturation,e_auto_brightness,e_auto_contrast,c_scale,q_auto:best,w_600/v1628782779/AgiosPage/agios-4_fzccbq.jpg',
        'https://res.cloudinary.com/rizeshouse/image/upload/e_auto_color,e_auto_saturation,e_auto_brightness,e_auto_contrast,c_scale,q_auto:best,w_600/v1628782769/AgiosPage/agios-5_p3muux.jpg',
        'https://res.cloudinary.com/rizeshouse/image/upload/e_auto_color,e_auto_saturation,e_auto_brightness,e_auto_contrast,c_scale,q_auto:best,w_600/v1628782782/AgiosPage/agios-6_vpfz1a.jpg',
        'https://res.cloudinary.com/rizeshouse/image/upload/e_auto_color,e_auto_saturation,e_auto_brightness,e_auto_contrast,c_scale,q_auto:best,w_600/v1628782772/AgiosPage/agios-7_cpqlcw.jpg',
      ],
    };
  },
  methods: {
    imageClicked(idx) {
      this.lightbox = true;
      this.lightboxIdx = idx;
    },
  },
};
</script>

<style scoped lang="scss"></style>
